import { RECRUITING_APPLY_URL } from './publicLinks';

// 採用サイトの募集要項（職種・報酬・稼働・勤務形態）の単一情報源。
// 報酬・稼働・勤務形態は 2026-10-16 の代表指示に基づく。
// 役割の説明は 採用_会社紹介資料 v0.2（ROLE 01〜03、メンバー紹介）に基づく。
export const APPLY_URL = RECRUITING_APPLY_URL;

// 会社紹介資料（職種別）は careersContent.js の RECRUIT_DECKS。

// 全職種共通の働き方
export const WORKSTYLE = {
  place: '原則対面。東京都港区麻布台1丁目8-10 麻布偕成ビル 3階（神谷町駅 徒歩7分）',
  remote: 'リモートでの稼働もできますが、フルリモートでの参加は受け付けていません。',
  hours: 'フルフレックス制。土日の稼働もできます。',
  evaluation: '毎月の評価の見直しで、昇給・昇格に早く反映します。',
};

export const FULLTIME_SALARY = '年収600万円〜（経験・役割に応じて決定）';

export const internshipTerms = {
  engineerExperienced: {
    label: 'エンジニア（実務経験あり）',
    pay: '時給2,000円〜',
    probation: '試用期間あり（試用期間中は時給1,750円）',
    hours: '週20時間以上',
  },
  engineerNew: {
    label: 'エンジニア（実務経験なし）',
    pay: 'ブートキャンプを経て、時給1,750円〜',
    probation: '試用期間あり（試用期間中は時給1,500円）',
    hours: '週30時間以上',
  },
  business: {
    label: '営業・コンサルティング',
    pay: '時給1,500円〜',
    probation: '試用期間あり',
    hours: '週30時間以上',
  },
};

// 職種別の募集。track: engineer（エンジニア）/ business（コンサルタント・ビジネス）
export const positions = [
  {
    id: 'ai-product-builder',
    track: 'engineer',
    type: '正社員',
    title: 'AI Product Builder',
    jp: 'AIエンジニア',
    catch: '学ぶ力を、AIでつくる力へ。',
    summary:
      'AIで実装し、理解・検証し、使える成果へ仕上げる。Trooperと顧客の業務課題に向き合い、Domain Product Leadと一緒に、課題から使われるものまでをつなぎます。',
    tasks: [
      'Trooperの製品群（Workhub・for Sales など）の設計・実装・検証',
      '顧客の業務に合わせた手順書・画面・業務アプリの開発',
      'Claude Code・Codex などを前提にした開発の進め方の改善',
    ],
    pay: FULLTIME_SALARY,
    hours: 'フルフレックス制',
  },
  {
    id: 'researcher',
    track: 'engineer',
    type: '正社員',
    title: 'Researcher',
    jp: 'Agent Evals・モデルの適応・Platform／Inference',
    catch: '研究を、Agentの性能と製品の改善へ。',
    summary:
      'Agentの評価、モデルの適応、実行と推論の基盤を担う。実行ログをタスクに分け、成果とトークンを結びつける Eval の研究を、品質・時間・費用の改善につなげます。',
    tasks: [
      'タスク単位の評価（Evals）の設計と、ハーネス・Agent構成・モデルの比較',
      '公開モデルを起点にした追加学習・蒸留などのモデルの適応',
      'GPU・推論基盤と、顧客ごとの独立環境での実行基盤の改善',
    ],
    pay: FULLTIME_SALARY,
    hours: 'フルフレックス制',
  },
  {
    id: 'fde',
    track: 'engineer',
    type: '正社員',
    title: 'Forward Deployed Engineer',
    jp: 'FDE',
    catch: '企業に入り込み、AIを業務に実装する。',
    summary:
      '顧客の現場に入り、業務を横で見ながらその場で作る。Trooperの基盤を使ったプロダクト開発や、コンサルタントと2名1組での常駐支援を担います。',
    tasks: [
      '顧客の現場での困りごとのヒアリングと、その場での実装',
      'Trooperの基盤を使った業務特化プロダクト（Trooper for Sales など）の開発',
      '現場の方が自分で作れるようにする、作り方の伝達・研修',
    ],
    pay: FULLTIME_SALARY,
    hours: 'フルフレックス制',
  },
  {
    id: 'engineer-intern',
    track: 'engineer',
    type: 'インターン',
    title: 'Engineering Intern',
    jp: 'エンジニアインターン',
    catch: '本番で使われるAIを、実務でつくる。',
    summary:
      '実務経験のある方は、すぐに開発の実務に入ります。実務経験がない方は、AI駆動開発ブートキャンプを経て参加できます。',
    tasks: [
      'LLMを活用したアプリケーション・エージェントの開発',
      'フロントエンド・API・データベースの実装とテスト',
      '顧客の案件や社内プロジェクトでのエンジニアリング',
    ],
    terms: [internshipTerms.engineerExperienced, internshipTerms.engineerNew],
  },
  {
    id: 'domain-product-lead',
    track: 'business',
    type: '正社員',
    title: 'Domain Product Lead',
    jp: '製品の判断と、Builderの育成',
    catch: '現場の知識を、製品の価値へ。',
    summary:
      '製品の価値と優先順位を決め、Builderの育成とチームの運営を担う。顧客の業務を深く理解し、誰の何を解くかを見立てて、使われ続ける製品を育てます。',
    tasks: [
      '顧客の業務課題の把握と、Trooperで任せる仕事・優先順位の決定',
      '受入条件の設計と、AI Product Builder との共同での製品づくり',
      'Builder の育成と、チームの運営',
    ],
    pay: FULLTIME_SALARY,
    hours: 'フルフレックス制',
  },
  {
    id: 'ai-consultant',
    track: 'business',
    type: '正社員',
    title: 'AI Consultant',
    jp: 'AIコンサルタント',
    catch: '課題の特定から、実装・定着まで。',
    summary:
      '企業へのAIの導入を、ユースケースの策定から導入まで、顧客の最前線で進める。Boostと一緒に企業の課題に入り、AIを使われ続ける形にします。',
    tasks: [
      'ヒアリング・業務の棚卸し・定量分析による課題の特定',
      'FDEチームとしての現場常駐と、効果と実現性による優先順位づけ',
      '内製化支援（研修・ブートキャンプ）の設計と事業開発',
    ],
    pay: FULLTIME_SALARY,
    hours: 'フルフレックス制',
  },
  {
    id: 'business-intern',
    track: 'business',
    type: 'インターン',
    title: 'Business Intern',
    jp: '営業・コンサルティングのインターン',
    catch: '任された仕事をやり切り、一つ上の仕事へ。',
    summary:
      '営業や顧客の案件に、ジュニアとして入ります。やり切った人には、一つ上の仕事を任せていきます。',
    tasks: [
      '営業・提案の準備と、顧客の案件のサポート',
      '業務の棚卸し・調査・資料作成',
      'AIを使った業務改善の試作',
    ],
    terms: [internshipTerms.business],
  },
];
